module.exports = __webpack_public_path__ + "img/eve_autonomy_diagram.b7c3cad7.png";